import { ComponentColumnCardGroup } from "types/CMS/KontentAI/content-types/column_card_group";
import { ComponentColumnCard } from "types/CMS/KontentAI/content-types/column_card";
import { assetResolver } from "./asset";
import { CtaResolver } from "./cta";
import { columnCard, columnCardGroup } from "types/CMS/Unum/columnCardGroup";
import { richTextResolver } from "./richText";
import { getUuid } from "utils/util";
import { createResolver } from "./Factories/ResolverFactory";
import { productTaxonomyResolver } from "./products";

export const columnCardGroupResolver = createResolver({
  resolve: (group: ComponentColumnCardGroup): columnCardGroup => {
    return {
      isFilterable: true,
      productTaxonomy: productTaxonomyResolver.resolve(group.elements.products)
        .result,
      key: getUuid(),
      type: "columnCardGroup",
      cards: ColumnCardResolver.resolve(group.elements.column_cards.linkedItems)
        .result,
      ctas: CtaResolver.resolve(group.elements.ctas.linkedItems).result,
    };
  },
});

const ColumnCardResolver = createResolver({
  resolve: (cards: ComponentColumnCard[]): columnCard[] => {
    return cards.map((card) => {
      const { elements } = card;

      return {
        type: "columnCard",
        title: elements.title.value,
        body: richTextResolver.resolve(elements.body).result,
        asset: assetResolver.resolve(elements.asset.linkedItems[0]).result,
      };
    });
  },
});

